__turbopack_context__.v({
  "detailsHeading": "wLwtZq_detailsHeading",
  "key": "wLwtZq_key",
  "popoverButton": "wLwtZq_popoverButton",
  "popoverKey": "wLwtZq_popoverKey",
  "popoverLabel": "wLwtZq_popoverLabel",
  "row": "wLwtZq_row",
  "tableContainer": "wLwtZq_tableContainer",
  "value": "wLwtZq_value",
});
